/**
 * Genesys specific Topics used to filter catalog results
 */
export enum Topic {
  AGENT_TOPIC = 'Agent',
  AGENT_INTERACTION_DESKTOP = 'Agent Interaction Desktop',
  AI_EXPERIENCE = 'AI Experience and Automation',
  API = 'API',
  ARCHITECT = 'Architect',
  AI = 'Artificial Intelligence',
  AUTO_KNOWLEDGE = 'Automatic knowledge and post-interaction automation',
  BASIC = 'Basic Functions',
  CHANNELS = 'Channels and Routing',
  CLOUD_MEDIA = 'Cloud Media Services',
  COACHING = 'Coaching',
  CONFIGURATION = 'Configuration',
  CORE = 'Core',
  DATA_ACTIONS = 'Data Actions',
  DECISIONS = 'Decisions',
  DIGITAL = 'Digital Channels',
  DIGITAL_CUSTOMER_ENGAGEMENT = 'Digital Customer Engagement',
  EDGE = 'Edge',
  EMPLOYEE_EX = 'Employee Performance (EX)',
  FORECASTING = 'Forecasting',
  GAMIFICATION = 'Gamification',
  GENESYS_BOTS = 'Genesys Bots',
  PREDICTIVE_ROUTING = 'Genesys Predictive Routing',
  PREDICTIVE_ENGAGEMENT = 'Genesys Predictive Engagement',
  INBOUND = 'Inbound and Routing',
  INTEGRATION = 'Integration',
  INTERACTION = 'Interaction and Screen Recording',
  JOURNEY_ANALYTICS = 'Journey Analytics',
  JOURNEY_DATA_MANAGEMENT = 'Journey Data Management',
  JOURNEY_MANAGEMENT = 'Journey Management',
  JOURNEY_ORCHESTRATION = 'Journey Orchestration​',
  JOURNEY_VISUALIZATION = 'Journey Visualization',
  KNOWLEDGE = 'Knowledge Management',
  LEADER = 'Leader',
  LEARNING = 'Learning Modules',
  MONITORING = 'Monitoring and Adherence',
  OUTBOUND = 'Outbound',
  PERFORMANCE = 'Performance Insights',
  PLATFORM = 'Platform',
  POINTILLIST_CJM = 'Pointillist/CJM',
  QM = 'Quality Management and Evaluations',
  REGULATORY_COMPLIANCE = 'Regulatory and Compliance',
  REPORTS = 'Reporting and Analytics',
  ROUTING = 'Routing',
  SALESFORCE = 'Salesforce',
  SCHEDULING = 'Scheduling',
  SCRIPTS = 'Scripting',
  SPEECH = 'Speech and Text Analytics',
  SUPERVISOR_MONITORING = 'Supervisor Monitoring',
  TIME_OFF = 'Time-off Management and Mobility App Tempo',
  UNIFIED_DESKTOP = 'Unified Desktop',
  VOICE = 'Voice of the Customer',
  WEM_EP = 'WEM - Employee Performance',
  WEM_QA = 'WEM - Quality Assurance and Compliance',
  WFM = 'WEM - Resource Management (WFM)',
  WORK_AUTOMATION = 'Work Automation',
  WEM = 'Workforce Engagement Management (WEM)',
}
